export default class Toggle {
  constructor(selector) {
    this.element = selector.jquery
      ? selector.get(0)
      : selector;
    this.toggleClassName = this.element.dataset.class || '';

    const targetSelector = this.element.dataset.target;
    this.target = document.querySelector(targetSelector);

    this.element.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.toggleClassName.length) {
        this.target.classList.toggle(this.toggleClassName);
      }
    });
  }
}
